import { Box, BoxProps } from '@chakra-ui/react';

interface ReceiptRowProps extends BoxProps {
  children: React.ReactNode;
}

export default function ReceiptRow({ children, ...props }: ReceiptRowProps) {
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="flex-start"
      alignSelf="stretch"
      gap={{ base: '4px', lg: '45px' }}
      flexDirection={{ base: 'column', lg: 'row' }}
      {...props}
    >
      {children}
    </Box>
  );
}
